import { render, staticRenderFns } from "./ProductDetailOptions.vue?vue&type=template&id=62b3a6dc&"
import script from "./ProductDetailOptions.vue?vue&type=script&lang=js&"
export * from "./ProductDetailOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports